//
//
//
//
//
//
//
import menu from '@/menu/modules/demo-components';
export default {
  data: function data() {
    return {
      menu: menu,
      banner: {
        title: 'COMPONENTS',
        subTitle: 'D2Admin 为你提供了一些上手即用的组件'
      }
    };
  }
};